export const SEND = 'SOCKET/SEND'
export const RECEIVED = 'SOCKET/RECEIVED'
export const SET_CONNECTION = 'SOCKET/SET_CONNECTION'
export const SUBSCRIBE = 'SOCKET/SUBSCRIBE'
export const UNSUBSCRIBE = 'SOCKET/UNSUBSCRIBE'
